import { atom } from 'recoil';
import { User } from './model';

export const userState = atom<User | null>({
  key: 'inputfile', // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
